import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=7ebce9fc"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebce9fc')) {
      api.createRecord('7ebce9fc', component.options)
    } else {
      api.reload('7ebce9fc', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=7ebce9fc", function () {
      api.rerender('7ebce9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/MenuItem.vue"
export default component.exports